module.exports = __webpack_public_path__ + "assets/img/card_sonance.a949037f.jpg";